import { GROUPED_REQUEST_STATUS } from 'src/api/constants/request'
import { WORK_ORDER_SCHEDULE_TYPES } from 'src/api/constants/workOrder'
import type { TrackingWorkOrderScheduling } from 'src/api/domains/service-tracking/serviceTracking.types'
import type { GroupedRequestStatus } from 'src/api/types/requests'

import { TIMELINE_PHASES, type TimelinePhase } from '../constants/timeline'

/**
 * Resolves the current timeline phase from request status and service details.
 * Completed status takes precedence, followed by a service date, then provider assignment.
 */
export const getTimelinePhase = (
  groupedRequestStatus: GroupedRequestStatus,
  scheduleType: TrackingWorkOrderScheduling['scheduleType'],
  hasProvider: boolean,
): TimelinePhase => {
  if (groupedRequestStatus === GROUPED_REQUEST_STATUS.COMPLETED) {
    return TIMELINE_PHASES.COMPLETED
  }

  if (scheduleType != null && scheduleType !== WORK_ORDER_SCHEDULE_TYPES.UNSCHEDULED) {
    return TIMELINE_PHASES.SERVICE_SCHEDULED
  }

  return hasProvider ? TIMELINE_PHASES.PROVIDER_ASSIGNED : TIMELINE_PHASES.PROVIDER_PENDING
}
